var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.configuration")) +
                " > " +
                _vm._s(_vm.$t("sidebar.assignskutowarehouse")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          !_vm.products.length
            ? _c("BaseNotFoundData", {
                attrs: {
                  title: _vm.$t("apps.inventory.message.notfoundskus"),
                  detail: _vm.$t("apps.inventory.message.createnewproducts")
                }
              })
            : _vm._l(_vm.form.warehouses, function(item, index) {
                return _c(
                  "Section",
                  { key: index },
                  [
                    _c("SectionHeader", {
                      attrs: {
                        title: _vm.$t(
                          "apps.inventory.message.assignskutowarehouse",
                          { value: item.whName }
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "FormRow",
                      [
                        _c(
                          "Col",
                          { attrs: { className: "col-lg-12" } },
                          [
                            !_vm.products.length
                              ? _c("BaseNotFoundData", {
                                  attrs: {
                                    title: _vm.$t(
                                      "apps.inventory.message.notfoundskus"
                                    ),
                                    detail: _vm.$t(
                                      "apps.inventory.message.createnewproducts"
                                    )
                                  }
                                })
                              : _c("BaseAssignSkus", {
                                  attrs: { items: item.items },
                                  model: {
                                    value: item.assignItems,
                                    callback: function($$v) {
                                      _vm.$set(item, "assignItems", $$v)
                                    },
                                    expression: "item.assignItems"
                                  }
                                })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
          _vm._v(" "),
          _vm.products.length
            ? _c("BaseFormAction", {
                attrs: {
                  textCancel: _vm.$t("button.cancel"),
                  textSubmit: _vm.$t("button.save"),
                  isSubmitted: _vm.isSubmitted
                },
                on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43fbc735", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43fbc735","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/configuration/AssignSku.vue
// module id = null
// module chunks = 